module.exports = __webpack_public_path__ + "static/media/ace.2e1e3afe.jpeg";